module.exports = __webpack_public_path__ + "static/media/logo-synapse.b0fbb852.svg";